// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/cssWithMappingToString.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".AddressList_listItem__36YHU{margin-bottom:20px}", "",{"version":3,"sources":["webpack://./src/bepaid/shared/modals/PaymentsCreationModal/components/SchedulePayment/components/AddressList/AddressList.module.scss"],"names":[],"mappings":"AAAA,6BAAU,kBAAkB","sourcesContent":[".listItem{margin-bottom:20px}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"listItem": "AddressList_listItem__36YHU"
};
export default ___CSS_LOADER_EXPORT___;
